import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

import { HtmlSanitizer } from 'helpers';

/**
 * This pipe is used to sanitize HTML that is styled with CSS.
 * As angular will strip out the style tags in the default sanitizer.
 * This is a workaround for that.
 */
@Pipe({
  name: 'sanitizedStyledHtml'
})
export class SanitizedStyledHtmlPipe implements PipeTransform {
  santitzer = new HtmlSanitizer();

  constructor(private domSanitizer: DomSanitizer) {}


  transform(html) {
    const cleaned = this.santitzer.SanitizeHtml(html);
    /* eslint-disable-next-line no-restricted-syntax -- input is run through HtmlSanitizer's
       tag/attribute allowlist above, which strips event handlers and non-allowlisted tags. */
    return this.domSanitizer.bypassSecurityTrustHtml(cleaned);
  }
}
